import { useContext } from 'react'
import { Redirect } from 'react-router-dom'

import PrivateRoute from '@/components/PrivateRoute'
import { ZentakeContext } from '@/utils/ZentakeContext'

import { FormsAnalyticsPage } from './FormsAnalyticsPage'

export const FormsAnalytics = () => {
  const { teamDetails } = useContext(ZentakeContext)

  if (!teamDetails?.analytics) {
    return <Redirect to="/forms" />
  }

  return (
    <PrivateRoute
      exact
      component={FormsAnalyticsPage}
      path={'/forms/analytics/:resourceId'}
    />
  )
}
